import crypto from "crypto-js";

export function generateSignature(payload, action, apiSecret) {
  const timestamp = Date.now().toString();
  // Convert payload to string
  const bodyString = JSON.stringify(payload || {});
  // Hash body to avoid huge strings
  const bodyHash = crypto.SHA256(bodyString).toString();
  const signature = crypto
    .SHA256(timestamp + action + bodyHash + apiSecret)
    .toString();
  return { signature, timestamp };
}
